import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';

const renderToolTip = titleText => (
  <Tooltip className="my-tooltip">{titleText}</Tooltip>
);
export default renderToolTip;
